import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AuthenticationService } from 'src/app/_services';

@Component({
  selector: 'app-modal-info-axa',
  templateUrl: './modal-info-axa.component.html',
  styleUrls: ['./modal-info-axa.component.css']
})
export class ModalInfoAXAComponent implements OnInit {

  constructor(
    private translate : TranslateService,
    private auth : AuthenticationService,
    private router : Router
  ) { }

  ngOnInit() {
  }

  loginAxA() {
    if (!this.auth.isAxA){
      this.auth.reloginAxA().subscribe( result =>{
        if (result){
          this.router.navigate(['/login/deliveryAxA']);
        }
      });
    }
  }


}
